import request from '@/utils/request'

// 新增泰山品质申报
export function addTspzsb(data) {
  return request({
    url: '/web/zlts/tspzsb',
    method: 'post',
    data: data
  })
}